import React, { Component } from 'react';
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export class LineItemSummary extends Component {

    constructor(props) {
        super(props);
        this.processOptionsString = this.processOptionsString.bind(this);
        this.showWarnings = this.showWarnings.bind(this);
    }

    processOptionsString(options) {
        var optionsArray = [];
        if (options) {
            optionsArray = options.split("");
            for (var i in optionsArray) {
                optionsArray[i] = optionsArray[i].split("");
            }
            console.log("OPTIONS ARRAY", optionsArray);
        }
        return optionsArray;
    }

    showWarnings(warnings) {
        var warningString = "";
        for (var i in warnings) {
            warningString += warnings[i] + "\n";
        }
        alert(warningString);
    }

    render() {
        var lineItemInfo = this.props.lineItemInfo;
        var options = this.processOptionsString(lineItemInfo.options);
        var itemWarnings = lineItemInfo.itemWarnings;
        return (
            <div className="nametag-line-summary">
                <h1>
                    {lineItemInfo.displayName}
                    {
                        lineItemInfo.closed
                            ? <div><span className="closed">LINE CLOSED</span></div>
                        :
                        itemWarnings.length > 0
                        &&
                        <div className="item-warnings" onClick={() => { this.showWarnings(itemWarnings) }}><FontAwesomeIcon icon={faExclamationTriangle} />
                            {
                                //map through item warnings and display them
                               itemWarnings.map(function (warning, idx) {
                                    return (
                                        <div key={idx}>
                                            {warning}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                </h1>
                <div className="nametag-info">
                    {
                        //Loop through the options and display them
                        options.map(function (option, idx) {
                            console.log("OPTION", option);
                            return (
                                <div key={idx} data-field-id={option[0]}>
                                    <h3>{option[2]} : {option[option.length - 1]}</h3>       
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}